//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const importData = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function uploadCSV(values) {
    try {
      const requestPayload = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/loyalty/upload-txn`,
        requestPayload
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    uploadCSV,
  };
};

export default importData;
